export const MAX_ACCOUNT_EXPIRY_YEARS = 3;

const DAY_MS = 24 * 60 * 60 * 1000;

export interface AccountExpiryBounds {
  readonly min: string;
  readonly max: string;
}

const toDateInputValue = (date: Date): string => date.toISOString().slice(0, 10);

/**
 * `YYYY-MM-DD` bounds in UTC for an account-expiry date input. The picked day is
 * sent as midnight UTC, so today is always "in the past" to the server; the max
 * clamps 29 Feb to 28 Feb the way Java's `plusYears` does.
 */
export function accountExpiryBounds(now: number = Date.now()): AccountExpiryBounds {
  const today = new Date(now);
  const year = today.getUTCFullYear() + MAX_ACCOUNT_EXPIRY_YEARS;
  const month = today.getUTCMonth();
  const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const max = new Date(Date.UTC(year, month, Math.min(today.getUTCDate(), lastDayOfMonth)));
  return { min: toDateInputValue(new Date(now + DAY_MS)), max: toDateInputValue(max) };
}

export function toExpiryDateInputValue(iso: string | null): string {
  return iso ? toDateInputValue(new Date(iso)) : '';
}

export function expiryDateInputToIso(value: string): string {
  return new Date(value).toISOString();
}

export function isExpiryDateInBounds(value: string, bounds: AccountExpiryBounds): boolean {
  return value >= bounds.min && value <= bounds.max;
}
